export default __webpack_public_path__ + "static/media/arbLogo.1fccaadc.png";